import React, { ReactNode } from 'react'
import { CubeIcon } from 'src/assets/icons/v2/CubeIcon'
import { HexagonIcon } from 'src/assets/icons/v2/HexagonIcon'
import { PyramidIcon } from 'src/assets/icons/v2/PyramidIcon'
import { SphereIcon } from 'src/assets/icons/v2/SphereIcon'

export interface IIcons {
  0: ReactNode
  1: ReactNode
  2: ReactNode
  3: ReactNode
}

interface IProps {
  value: keyof IIcons
}

export const BillingIcon = ({ value }: IProps) => {
  const icons: IIcons = {
    0: <SphereIcon size={50} />,
    1: <PyramidIcon size={50} />,
    2: <CubeIcon size={50} />,
    3: <HexagonIcon size={50} />,
  }
  return <div>{icons[value]}</div>
}
